import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';

interface TableBodyProps {
  children: React.ReactNode;
  className?: string;
}

export function TableBody({children, className}: TableBodyProps) {
  return (
    <div className={classNames(styles.tableBody, className)}>{children}</div>
  );
}

export default TableBody;
